import React, {Component} from 'react';
import style from './Project_info1.module.css';
import Logo from '../../image/icon/index_logo.png';
import Menu from '../../image/icon/icon_menu.png';
import SeeAll from '../../image/icon/see_all.png';
import Jiantou from '../../image/icon/jiantou.png';
import $ from  'jquery';
import creatHistory from 'history/createHashHistory';
import MenuSide from "../../compents/menuSid/MenuSide";
import { Player } from 'video-react';
import '../../../node_modules/video-react/dist/video-react.css'
import Zhonghe from "../../image/temp/zhonghe.jpg";
import Taobao from "../../image/temp/taobao.png";
import Alibaba from "../../image/temp/alibaba.png";
class ProjectInfo1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:null,
            isMobile:false,
            menuState:false,
            videoWith:0
        };
        // this.indexChange.bind(this);
    }
    componentDidMount() {
        var that=this;
        $.ajax({
            type:'get',
            url:'/article/article.json',
            success:function(data){
                that.setState({
                    data:data[that.props.match.params.projectid-1]
                })
            }
        })
        window.addEventListener("resize",this.indexChange.bind(this));
        this.indexChange();
    }
    componentWillUnmount(){
        window.removeEventListener('resize',this.indexChange)
    }
    indexChange(){
        this.setState({isMobile: window.innerWidth <= 760});
        if (this.state.isMobile){
            this.setState({
                videoWith:"auto"
            })
        } else{
            this.setState({
                videoWith:570
            })
        }
    }
    handleScrollTop=()=>{
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
        });
    }
    seeAll=()=>{
        const history = creatHistory();
        history.goBack();
    }
    goHome=()=>{
        this.props.history.push('/')
    }
    showMenu=()=>{
        this.setState({
            // menuState:!this.state.menuState
        })
    }
    render() {
        return (
            this.state.data!==null? <div className={style.project_info}>
                {this.state.isMobile?<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <img className={style.menu} src={Menu} title="Menu" onClick={(e)=>this.showMenu(e)}/>
                </div>:<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <ul>
                        <li>公司行业</li>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>
                </div>}
                <div className={style.article_container}>
                    <div className={style.introduction_container}>
                        <div className={style.introduction_content}>
                            <p className={style.introduction_title}>{this.state.data.title}</p>
                            <div className={style.line}></div>
                            <div className={style.author}>
                            <div className={style.cl}>
                                <p className={style.orange}>客户类型</p>
                                <p>{this.state.data.client}</p>
                            </div>
                            <div className={style.cl}>
                                <p className={style.orange}>产品与服务</p>
                                <p>{this.state.data.solutions}</p>
                            </div>
                            </div>
                        </div>
                        {this.state.data.video?<div className={style.video_play}><Player ref="player"  autoPlay={true}>
                            <source src={this.state.data.video} />
                        </Player></div>:<img src={this.state.data.title_img}/>}

                    </div>
                    <div className={style.article_top}>
                        <img src={this.state.data.content1_img}/>
                        <p>{this.state.data.content1}</p>
                    </div>
                    <div className={style.article_middle}>
                        <img src={this.state.data.content2_img}/>
                    </div>
                    <div className={style.article_end}>
                        <p>{this.state.data.content3}</p>
                        <img src={this.state.data.content3_img}/>
                    </div>
                </div>
                <div className={style.see_all} onClick={this.seeAll}>
                    <img src={SeeAll}/>
                    <p>查看所有案例</p>
                </div>
                <div className={style.footer} onClick={this.handleScrollTop}>
                    <div className={style.top_btn}>
                        <img src={Jiantou}/>
                        <p>顶部</p>
                    </div>
                    <ul>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>
                    <div className={style.qrcode_wrap}>
                        <img src={Zhonghe}></img>
                        <img src={Taobao}></img>
                        <img src={Alibaba}></img>
                    </div>
                    <a className={style.bottom} href={`https://beian.miit.gov.cn`}>
                        <p>Copyright © 2019 eyemove.All right reserved</p>
                        <p> 沪ICP备15012399号-1</p>
                    </a>
                </div>
                <MenuSide menuState={this.state.menuState} close={(e)=>this.showMenu(e)}></MenuSide>
            </div>:""
        );
    }
}

export default ProjectInfo1;